import React, {forwardRef, useState} from 'react';
import css from './css/IconButton.module.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const IconButton = forwardRef(({ icon, bg = "transparent", color = "black", border = undefined, borderColor = color, disabled = false, onClick, className = undefined, keepPropagation = false, ...props }, ref) => {
  const [isFocused, setIsFocused] = useState(false);

  const btnStyles = {
    backgroundColor: bg,
    color: color.startsWith('--') ? `var(${color})` : color,
    borderColor: borderColor,
    outline: 'none',
    boxShadow: isFocused ? (`0 0 0 0.2rem ${bg}50`) : 'none',
  }

  return (
    <button
      ref={ref}
      style={btnStyles}
      disabled={disabled}
      className={`${css.btn} ${border && css.border} ${className}`}
      onClick={(e) => {
        e.preventDefault();
        if(!keepPropagation)
        {
          e.stopPropagation();
        }
        onClick && onClick(e);
      }}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      {...props}
    >
      <FontAwesomeIcon icon={icon}/>
    </button>
  );
});

export default IconButton;